<div class="loader-meessage">{{message}}</div>
<p-progressBar mode="indeterminate" [style]="{ height: '6px' }" />
